import { t } from "@/i18n-js/instance";
import { useLatestInvoice } from "@circle-react/hooks/account_payment_processor/useLatestInvoice";
import { Button } from "@circle-react-uikit/Button";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";
import { WarningWrapper } from "./WarningWrapper";

export const SubscriptionWithIncompletePayment = () => {
  const { isLoadingInvoice, onRetrieveLatestInvoice, latestInvoice } =
    useLatestInvoice();

  if (latestInvoice?.hosted_invoice_url) {
    window.location.replace(latestInvoice.hosted_invoice_url);
  }

  return (
    <WarningWrapper>
      {isLoadingInvoice && <Loader variant="fullscreen" />}
      <Typography.LabelLg weight="semibold">
        {t("subscription.incomplete_reactified.title")}
      </Typography.LabelLg>
      <Typography.BodyMd color="text-default">
        {t("subscription.incomplete_reactified.description")}
      </Typography.BodyMd>
      <div className="inline-block">
        <Button
          variant="secondary"
          disabled={isLoadingInvoice}
          onClick={onRetrieveLatestInvoice}
        >
          {t("subscription.incomplete_reactified.action")}
        </Button>
      </div>
    </WarningWrapper>
  );
};
